import { useEffect } from 'react';

export interface UseRequestCleanupProps {
  cancelAllRequests: () => void;
}

/**
 * Cleans up pending requests on component unmount
 * Ensures no memory leaks or pending requests after component is destroyed
 */
export function useRequestCleanup({ cancelAllRequests }: UseRequestCleanupProps): void {
  useEffect(() => {
    return () => {
      try {
        cancelAllRequests();
      } catch (error) {
        // Silent error handling
      }
    };
  }, [cancelAllRequests]);
}
